import React, { Component } from 'react'
import Login from './components/login'
import Directory from './containers/directoryContainer.js'
import './App.css'
import firebase, { db } from 'firebase'
import data from './data.json'
import { addTagsSearch } from './func/skills.js'
import Loader from './components/loader'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userSignIn: false,
      loading: false,
      admin: false,
      user: {
        email: '',
        password: ''
      },
      mediaQuery: 'desktop'
    }
  }

  setMediaQuery = () => {
    if ('matchMedia' in window) {
      if (window.matchMedia('(max-width: 920px)').matches) {
        this.setState(
          () => ({
            mediaQuery: 'smartphone'
          }),
          () => console.log(this.state.mediaQuery)
        )
      } else if (window.matchMedia('(min-width: 1200px)').matches) {
        this.setState({
          mediaQuery: 'desktop'
        })
        // } else if (
        //   window.matchMedia('(min-width : 450px) and max-width: 1200').matches
        // ) {
        //   this.setState({
        //     mediaQuery: 'tablet'
        //   })
      } else {
        this.setState({
          mediaQuery: 'desktop'
        })
      }
      setTimeout(() => console.log(this.state.mediaQuery), 0)
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.setMediaQuery)
    this.setLoading(true)
    this.setMediaQuery()
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          userSignIn: user
        })
        firebase
          .firestore()
          .collection('admin')
          .where('uid', '==', user.uid)
          .get()
          .then(querySnapshot => {
            if (querySnapshot.docs.length != 0) {
              querySnapshot.forEach(doc => {
                if (doc.exists) {
                  this.setState({ admin: true })
                  console.log('Admin in')
                  // firebase
                  //   .firestore()
                  //   .collection('members')
                  //   .get()
                  //   .then(querySnap => {
                  //     querySnap.forEach((item, i) => {
                  //       let data = item.data()
                  //       firebase
                  //         .firestore()
                  //         .collection('members')
                  //         .doc(item.id)
                  //         .update(addTagsSearch(data))
                  //         .then(() => console.log(i, item.id, ' => updated'))
                  //     })
                  //   })
                } else {
                  this.setState({ admin: false })
                }
              })
            } else {
              this.setState({ admin: false })
            }
          })
          // .then(() => {
          //   this.setLoading(false)
          // })
          .catch(function(error) {
            console.log('Error getting documents: ', error)
          })
      } else {
        this.setLoading(false)
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        userSignIn: nextProps.user
      })
    }
  }

  handleLoginChange = ({ target }) => {
    let user = this.state.user
    user[target.name] = target.value

    this.setState({
      user
    })
  }

  handleSubmit = () => {
    this.props.signIn(this.state.user.email, this.state.user.password)
    let user = { ...this.state.user }
    user.password = ''
    this.setState({
      user: user
    })
    this.setLoading(true)
  }

  handleResetPassword = () => {
    let user = { ...this.state.user }
    this.props.resetPassword(user.email)
  }

  setLoading = bool => {
    this.setState({
      loading: bool
    })
  }

  render() {
    return (
      <div
        style={{
          overflow: 'hidden',
          width: '100vw',
          height: '100vh'
        }}
      >
        {this.state.loading ? (
          <Loader mediaQuery={this.state.mediaQuery} />
        ) : (
          ''
        )}

        {this.state.userSignIn ? (
          <Directory
            admin={this.state.admin}
            mediaQuery={this.state.mediaQuery}
            setLoading={bool => this.setLoading(bool)}
            loading={this.state.loading}
          />
        ) : (
          <Login
            email={this.state.user.email}
            handleChange={({ target }) => this.handleLoginChange({ target })}
            submit={this.handleSubmit}
            user={this.state.user}
            handleResetPassword={this.handleResetPassword}
            mediaQuery={this.state.mediaQuery}
          />
        )}
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js